const React = require("react");
const {openPopupWindow, openV1PopupInfo} = require("../../../../../../../emitters/popup");
const Popup = require("../../../../../../dumb/Popup/C");
const Loading = require("../../../../../../dumb/Loading");
const {apiAdminCustomerRefundStatusRecursiveCheck} = require("../../../../../../../api/admin/refunds");

module.exports = (refund, update) => openPopupWindow((setPopupState, popup, onMount) => {
  const {close} = popup;

  const showResult = (infoArgs) => {
    update && update()
    close();
    setTimeout(() => {
      openV1PopupInfo(infoArgs)
    }, 500);
  }

  onMount(() => {
    const issue_id = refund.id;
    apiAdminCustomerRefundStatusRecursiveCheck({issue_id}, (response, resolve, reject) => {
      const {
        refund_status,
        refund_lifeflow
      } = response;

      const statuses = [refund_status, refund_lifeflow];

      if (statuses.includes('withdrawal_done')) {
        resolve();
      } else if (statuses.includes('canceled')){
        reject();
      }
    }).then(() => showResult(['Success', `Payout ${issue_id} has been started`]))
      .catch(() => showResult(['Error', `Payout ${issue_id} hasn't been started`])).cancel
  })

  return (stateOfPopup) => {
    return (
      <Popup caption={(
        <div className="layoutRow fhaS fvaC w">
          <div>Waiting for refund completion</div>
        </div>
      )}
     >
        <div className="h60 rlv mt50 c0>.CircularProgress">
          <Loading/>
        </div>
      </Popup>
    );
  };
});
